import { Box, Typography } from "@mui/material";
import Link from "next/link";
import { observer } from "mobx-react-lite";
import ThemeStore from "../stores/ThemeStore";
import Divider from "@mui/material/Divider";

const AuthentigateFooter = observer(({ cartUrl }: { cartUrl: string }) => {
    return (
        <footer>
            <Box
                sx={(theme) => ({
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "center",
                    alignItems: "center",
                    py: 2,
                    mt: 2,
                    backgroundColor: `${theme.palette.background.paper}75`,
                })}
            >
                <Link href="https://authentigate.ca" target="_blank">
                    <img
                        src="https://tickets.authentigate.ca/uploads/28/ag-black-transparent.png"
                        alt="Powered by AuthentiGATE"
                        style={{
                            display: "block",
                            width: "200px",
                            maxWidth: "90%",
                            filter:
                                ThemeStore.mode === "dark"
                                    ? "invert(100%)"
                                    : "none",
                            marginBottom: "8px",
                        }}
                    />
                </Link>
                <Divider
                    flexItem
                    orientation="vertical"
                    sx={{ mr: 2, display: { xs: "none", md: "block" } }}
                />
                <Divider
                    flexItem
                    orientation="horizontal"
                    sx={{ my: 1, display: { xs: "block", md: "none" }, mx: 3 }}
                />
                <Box>
                    <Link
                        href="https://s3.amazonaws.com/esc-bkt-static/ag-tickets/html/privacy-policy.html"
                        target="_blank"
                    >
                        <Typography
                            color="textPrimary"
                            variant="body2"
                            fontWeight={600}
                            sx={{ textAlign: { xs: "center", md: "left" } }}
                        >
                            Privacy Policy
                        </Typography>
                    </Link>
                    <Link href={`/store/${cartUrl}/retrieve-previous-orders`}>
                        <Typography
                            color="info.light"
                            variant="body2"
                            fontWeight={600}
                            sx={{ textAlign: { xs: "center", md: "left" } }}
                        >
                            Retrieve Previous Orders
                        </Typography>
                    </Link>
                </Box>
            </Box>
        </footer>
    );
});

export default AuthentigateFooter;
